<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishByOrgApproved.p1')}}
    {{news.textParams[2]}}
    <router-link
      :to="{name: 'ProposalView', params: {id: news.textParams[3]}}"
    >{{news.textParams[4]}}</router-link>
    {{$t('news.template.proposal.publishByOrgApproved.p2')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>.
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>
    {{$t('news.template.proposal.publishByOrgApproved.p3')}}
    {{news.textParams[2]}}
    {{$t('news.template.proposal.publishByOrgApproved.p4')}}
    {{news.textParams[7]}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
      {{$t('news.template.proposal.publishByOrgApproved.p5')}}
    </router-link>
    {{$t('news.template.proposal.publishByOrgApproved.p6')}}
  </div>
</template>
